import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardContent,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@material-ui/core";
import Done from "@material-ui/icons/Done";
import Error from "@material-ui/icons/Error";
import FileUpload from "@material-ui/icons/CloudUpload";

const getIcon = function(status) {
  switch (status) {
    case "success":
      return <Done />;
    case "pending":
      return <FileUpload />;
    default:
      return <Error />;
  }
};

const FileListCard = props => (
  <Card style={{ maxHeight: props.height, overflow: "auto" }}>
    <CardHeader title="Uploaded raw files" />
    <CardContent>
      {props.soloIsFetching ? (
        <LinearProgress />
      ) : (
        <List>
          {props.soloRawFiles.map(file => (
            <ListItem key={file.id} button>
              <ListItemIcon>{getIcon(file.status)}</ListItemIcon>
              <ListItemText
                primary={file.name}
                secondary={file.message}
                style={{ wordWrap: "break-word" }}
              />
            </ListItem>
          ))}
        </List>
      )}
    </CardContent>
  </Card>
);

FileListCard.propTypes = {
  height: PropTypes.number.isRequired,
  soloRawFiles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      status: PropTypes.string,
      name: PropTypes.string.isRequired,
      message: PropTypes.string
    })
  ).isRequired,
  soloIsFetching: PropTypes.bool.isRequired
};

FileListCard.defaultProps = {
  height: 400
};

export default FileListCard;
